﻿import { IEmailExcelId } from './email-excel-id';

export interface IEmailType {
    id: number;
    emailFamilyId: number;
    name: string;
    emailExcelIds: IEmailExcelId[];
}
